import { Component, OnInit } from "@angular/core";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-portada",
  templateUrl: "./portada.component.html",
  styleUrls: ["./portada.component.css"],
})
export class PortadaComponent implements OnInit {
  menuItems = [
    { nombre: "Corderos", icono: faTractor, ruta: "/entregaOpcion" },
    { nombre: "Cambiar Clave", icono: faKey, ruta: "/mdfclave" },
    { nombre: "Liquidaciones", icono: faEuroSign, ruta: "/liquida" },
    { nombre: "Piensos", icono: faTractor, ruta: "/piensoOpcion" },
    { nombre: "Facturas", icono: faFileInvoice, ruta: "/factura" },
    { nombre: "Anticipos", icono: faMoneyBill, ruta: "/anticipo" },
  ];

  constructor(private srvCentral: CentralService) {}

  ngOnInit(): void {}
}
